import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import { toWords } from 'number-to-words';
import withAuthorization from "../components/authentication";
import Navbar from '../components/Navbar';
const CholaGSTInvoiceForm = () => {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [formData, setFormData] = useState({
  invoicePeriodFrom: "",
  invoiceNo : "",
  invoicePeriodTo: "",
  customerName: "",
  Amount: "",
});
const [entries, setEntries] = useState([
  { customerName: "", Amount: "" },
]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  
    const [tokenCount, setTokenCount] = useState(null); // State to hold the token count
    const [error, setError] = useState(null); // State to handle any errors
    const [showModal, setShowModal] = useState(false);

    const formatMonthYear = (value) => {
  if (!value) return "";

  const [year, month] = value.split("-");
  const date = new Date(year, month - 1);

  return date.toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  });
};

const handleEntryChange = (index, field, value) => {
  const updated = [...entries];
  updated[index][field] = value;
  setEntries(updated);
};

const addEntry = () => {
  setEntries([...entries, { customerName: "", Amount: "" }]);
};

const removeEntry = (index) => {
  if (entries.length === 1) return;
  setEntries(entries.filter((_, i) => i !== index));
};


    const numberToWordsIndian = (num) => {
      if (num === 0) return "ZERO"; // Explicitly handle 0 case
    
      const belowTwenty = [
        "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
        "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
      ];
    
      const tens = [
        "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
      ];
    
      const placeValues = ["", "Thousand", "Lakh", "Crore"];
    
      let parts = []; // Store number parts in words
      let place = 0;  // Index to track Thousand, Lakh, Crore
    
      while (num > 0) {
        let chunk;
        if (place === 0) {
          // First chunk is three digits
          chunk = num % 1000;
          num = Math.floor(num / 1000);
        } else {
          // After first chunk, all others are two digits
          chunk = num % 100;
          num = Math.floor(num / 100);
        }
    
        if (chunk > 0) {
          const words = convertChunk(chunk, belowTwenty, tens);
          parts.unshift(words + (placeValues[place] ? " " + placeValues[place] : ""));
        }
        place++;
      }
    
      return parts.length > 0 ? parts.join(" ").trim().toUpperCase() : "ZERO";
    }
    
    function convertChunk(num, belowTwenty, tens) {
      if (num === 0) return ""; // Ensure empty chunks don't contribute
      if (num < 20) return belowTwenty[num];
      if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + belowTwenty[num % 10] : "");
      return belowTwenty[Math.floor(num / 100)] + " Hundred" + (num % 100 !== 0 ? " " + convertChunk(num % 100, belowTwenty, tens) : "");
    }

    const centerPad = (text, width) => {
  text = String(text);
  if (text.length >= width) return text;

  const totalSpaces = width - text.length;
  const left = Math.floor(totalSpaces / 2);
  const right = totalSpaces - left;

  return " ".repeat(left) + text + " ".repeat(right);
};

const numberToWordsWithPaise = (num) => {
  if (num === null || num === undefined || isNaN(num)) {
    return "ZERO";
  }

  num = Number(num);

  const rupees = Math.floor(num);
  const paise = Math.round((num - rupees) * 100);

  const rupeesWords = numberToWordsIndian(rupees);

  // Case 1: Only Paise (like 0.51)
  if (rupees === 0 && paise > 0) {
    const paiseWords = numberToWordsIndian(paise);
    return `RUPEES ${paiseWords} PAISA ONLY`;
  }

  // Case 2: Rupees + Paise
  if (paise > 0) {
    const paiseWords = numberToWordsIndian(paise);
    return `RUPEES ${rupeesWords} AND ${paiseWords} PAISA ONLY`;
  }

  // Case 3: Only Rupees
  return `RUPEES ${rupeesWords} ONLY`;
};

const serialNumbers = entries.map((_, i) => i + 1).join("     \n");
const customerNames = entries.map(e => e.customerName || "N/A").join("    \n");
const AMOUNT_COL_WIDTH = 14; // adjust if needed

const amounts = entries
  .map(e => {
    const formatted = Number(e.Amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return centerPad(formatted, AMOUNT_COL_WIDTH);
  })
  .join("\n");


  const totalAmount = entries.reduce(
  (sum, e) => sum + Number(e.Amount || 0),
  0
);

const sgst = totalAmount * 0.09;
const cgst = totalAmount * 0.09;
const grandTotal = totalAmount + sgst + cgst;

const formatAmount = (num) =>
  num.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });


const gstBreakup = [
  { label: "Total Amt", value: formatAmount(totalAmount) },
  { label: "SGST 9%", value: formatAmount(sgst) },
  { label: "CGST 9%", value: formatAmount(cgst) },
  { label: "Grand Total", value: formatAmount(grandTotal) },
];


const drawDividedAmountCell = (doc, x, y, width, height, rows) => {
  const rowHeight = height / rows.length;

  rows.forEach((row, index) => {
    const rowY = y + index * rowHeight;

    // Draw horizontal divider
    if (index !== 0) {
      doc.line(x, rowY, x + width, rowY);
    }

    // Label
    doc.setFontSize(9);
    doc.setFont(
      "bold",
     
    );

    doc.text(row.label, x + 2, rowY + rowHeight / 2 + 2);

    // Value (right aligned)
    doc.text(
      row.value,
      x + width - 2,
      rowY + rowHeight / 2 + 2,
      { align: "right" }
    );
  });
};



  const generateInvoice = () => {
    const doc = new jsPDF({
      unit: 'mm',
      format: [210, 282], // A4 width (210mm) and increased height (350mm)
    });

    // Full-width header image
    const imgWidth = 210; // A4 width in mm
    const imgHeight = 50;
    doc.addImage(
        'https://res.cloudinary.com/dztz5ltuq/image/upload/v1741759136/PdfImage_dsk0mx.png',
        'PNG',
        0,
        0,
        imgWidth,
        imgHeight
    );

    // Full-width line
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.line(0, 50, pageWidth, 50);

    // Set font to bold for REF and Date
    doc.setFont('helvetica', 'bold');
    doc.text('Dealer Code : 60344', 8, 60);

    // Date
    const indianDate = new Date(Date.now()).toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
    });
    console.log("Today's Date (IST):", indianDate);
    
    
    doc.text(`Date: ${indianDate}`, pageWidth - 50, 60);

    // Table settings
    const margin = 20; // Left margin
    const startY = 68; // Start position for the table
    const rowHeights = [8, 37, 12, 70, 25]; // Row heights
    const colWidths = [91, 77]; // Columns for row 2 (example)

    
    
    // Example usage
     // Output: FIVE LAKH NINETY NINE THOUSAND NINE HUNDRED NINETY NINE
    
    
    // Example usage
     // Output: "FOUR LAKH NINETY NINE THOUSAND NINE HUNDRED NINETY NINE"
    const h = numberToWordsWithPaise(grandTotal);   

    // PAYMENT MODE
    const paymentM = 
  formData.paymentMode === "Cash" 
    ? "Cash" 
    : (formData.paymentMode === "Personal Account" || formData.paymentMode === "Company Account") 
      ? "In Account" 
      : "Unknown";


      
    // Data
    const tableData = [
        ['PAYOUT TAX INVOICE'], // Row 1
        [
            `Party Details :\nCholaMandlam Investment and Finance Co. Ltd.\nBranch Address: Ground Flour Nai Sadak , ShahzadPur , Akbarpur, Ambedkar Nagar, Uttar Pradesh 224122\nDisst: Akbarpur, Ambedkar Nagar, Uttar Pradesh 
GSTIN : 09AAACC1226H1Z2`,
            `INVOICE No : ${formData.invoiceNo}\nDate : ${indianDate} \nPlace of Supply : Uttar Pradesh \nInvoice Period : ${formatMonthYear(formData.invoicePeriodFrom)} - ${formatMonthYear(formData.invoicePeriodTo)}\nReverse Charge : YES`,
        ], // Row 2
        ['S.No', ' Desciption of Goods/Loan HSN/SAC/Agreement No', 'Amount'], // Row 3
       [
  serialNumbers,
  customerNames,
  amounts
],
 // Row 4
        [`Total Payment Received in Rupees:\n${h}`, `Total Payment Received: Rs. ${formData.tokenAmount}\nPayment Mode: ${paymentM}`], // Row 5
    ];

    let y = startY;

    // Function to draw wrapped text inside a cell
   const drawWrappedText = (
  text,
  x,
  y,
  maxWidth,
  lineHeight = 5,
  fontSize = 9,
  rowHeight = 8,
  isFirstRow = false,
  align = "left" // 👈 NEW
) => {
  doc.setFontSize(fontSize);
  const lines = doc.splitTextToSize(text, maxWidth);

  lines.forEach((line, index) => {
    let textX = x;

    if (align === "center") {
      textX = x + maxWidth / 2;
    }

    if (isFirstRow && index === 0) {
      const horizontalCenter = x + maxWidth / 2;
      const verticalCenter = y + (rowHeight - fontSize) / 2;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);

      doc.text(line, horizontalCenter, verticalCenter, {
        align: "center",
      });
    } else {
      doc.text(line, textX, y + index * lineHeight, {
        align: align,
      });
    }
  });
};


    // Function to draw a single row
    const drawRow = (rowData, colWidths, rowHeight, isFirstRow = false) => {
  let x = margin;

  rowData.forEach((cellText, colIndex) => {
    const colWidth = colWidths[colIndex];

    doc.rect(x, y, colWidth, rowHeight);

    // 👇 Center ONLY Amount column (3rd column)
    const align = colIndex === 2 ? "center" : "left";

    drawWrappedText(
      cellText,
      x + 2,
      y + 5,
      colWidth - 4,
      5,
      9,
      rowHeight,
      isFirstRow,
      align // 
    );

    x += colWidth;
  });

  y += rowHeight;
};


    // Draw table rows
    drawRow(tableData[0], [168], rowHeights[0], true); // Row 1: 1 column (first row centered)
    drawRow(tableData[1], colWidths, rowHeights[1]); // Row 2: 2 columns
    drawRow(tableData[2], [20, 71, 77], rowHeights[2]); // Row 3: 5 columns
    drawRow(tableData[3], [20, 71, 77], rowHeights[3]); // Row 4: 5 columns
    // drawRow(tableData[4], colWidths, rowHeights[4]); // Row 5: 2 columns

    // Draw row border manually
let x = margin;

const yBefore = y;

// First column
doc.rect(x, y, colWidths[0], rowHeights[4]);
drawWrappedText(
  tableData[4][0],
  x + 2,
  y + 5,
  colWidths[0] - 4
);
x += colWidths[0];

// Second column (DIVIDED)
doc.rect(x, y, colWidths[1], rowHeights[4]);

// SIMPLE vertical divider inside 2nd column
doc.line(
  x + colWidths[1] / 2,
  y,
  x + colWidths[1] / 2,
  y + rowHeights[4]
);


drawDividedAmountCell(
  doc,        // ✅ PASS doc
  x,
  y,
  colWidths[1],
  rowHeights[4],
  gstBreakup
);

y += rowHeights[4];


    doc.text(`For TRUST N RIDE`, pageWidth - 50, 237);
    

    const imgWidth1 = 40; // A4 width in mm
    const imgHeight1 = 20;
    doc.addImage(
        'https://res.cloudinary.com/dztz5ltuq/image/upload/v1734425018/WhatsApp_Image_2024-12-17_at_14.05.25_785b0425-removebg-preview_f8eoli.png',
        'PNG',
        pageWidth - 40,
        240,
        imgWidth1,
        imgHeight1
    );
    doc.addImage(
        'https://res.cloudinary.com/dztz5ltuq/image/upload/v1734425018/WhatsApp_Image_2024-12-17_at_14.05.25_fded720a-removebg-preview_gnew8h.png',
        'PNG',
        pageWidth - 80,
        240,
        imgWidth1,
        imgHeight1
    );

    
    doc.line(0, 270, pageWidth, 270);
    doc.setFont("helvetica", "bold"); // Use "bold" for a darker heading
    doc.setFontSize(12); // Adjust the size for a heading style

    // Add the text with a bold style
    
    doc.text('This is a system-generated invoice, e signed and approved for authenticity. For any inquiries or \nsupport, you can reach us via our website at https://www.trustnride.in/ or email at team@trustnride.in', 3, 276);

    // Open PDF in a new tab
   var blobUrl = doc.output('bloburl');
  
     
  window.open(blobUrl, '_blank');
   //doc.save();
//    const pdfBlob = doc.output("blob");
//    return new File([pdfBlob], "token_invoice.pdf", { type: "application/pdf" });
};

  //count invoice from backend
  // Function to fetch token count from the backend

  

  const [loading, setLoading] = useState(false);

const handleSubmit = async () => {
  if (!formData.invoicePeriodFrom || !formData.invoicePeriodTo) {
    alert("Please select invoice period");
    return;
  }

  const hasInvalid = entries.some(
    e => !e.customerName || !e.Amount
  );

  if (hasInvalid) {
    alert("Please fill all customer names and amounts");
    return;
  }

  generateInvoice();
  setSubmissionSuccess(true);
};


  

  return (
   <div>
    <Navbar />

    <div className="container mx-auto my-10 p-5 border rounded shadow">

      <h1 className="text-2xl font-bold mb-6">GST Invoice</h1>
{/* Invoice Number */}
<div className="mb-6">
  <label className="block font-semibold mb-2">
    Invoice No
  </label>
  <input
    type="text"
    name="invoiceNo"
    value={formData.invoiceNo}
    onChange={handleChange}
    placeholder="Enter Invoice Number"
    className="w-full p-2 border rounded"
    required
  />
</div>

      {/* Invoice Period */}
      <div className="mb-6">
        <label className="block font-semibold mb-2">
          Invoice Period (From – To)
        </label>
        <div className="flex gap-4">
          <input
            type="month"
            name="invoicePeriodFrom"
            value={formData.invoicePeriodFrom}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="month"
            name="invoicePeriodTo"
            value={formData.invoicePeriodTo}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>
      </div>

      {/* Customer Entries */}
      <h2 className="text-lg font-semibold mb-3">Customer Entries</h2>

      {entries.map((entry, index) => (
        <div
          key={index}
          className="flex gap-4 items-center mb-3"
        >
          <input
            type="text"
            placeholder="Customer Name"
            value={entry.customerName}
            onChange={(e) =>
              handleEntryChange(index, "customerName", e.target.value)
            }
            className="w-1/2 p-2 border rounded"
            required
          />

          <input
            type="number"
            placeholder="Amount"
            value={entry.Amount}
            onChange={(e) =>
              handleEntryChange(index, "Amount", e.target.value)
            }
            className="w-1/3 p-2 border rounded"
            required
          />

          {entries.length > 1 && (
            <button
              type="button"
              onClick={() => removeEntry(index)}
              className="text-red-600 font-bold text-xl"
            >
              ×
            </button>
          )}
        </div>
      ))}

      <button
        type="button"
        onClick={addEntry}
        className="text-blue-600 font-semibold mb-6"
      >
        + Add another entry
      </button>

      {/* Generate */}
      <button
        onClick={handleSubmit}
        className="w-full bg-blue-600 text-white p-3 rounded font-semibold"
      >
        Generate Invoice
      </button>

      {submissionSuccess && (
        <p className="mt-4 text-green-600 font-semibold">
          Invoice generated successfully
        </p>
      )}
    </div>
  </div>
  );
};

export default   withAuthorization(CholaGSTInvoiceForm, ["admin", "Employee"]);
